export default __webpack_public_path__ + "static/media/ico_location.3a4a0c75.svg";